import rewardSVG from 'assets/icons/rewards.svg'
import close from 'assets/icons/close.svg'
import { formatCurrency } from 'toolbox/format'

export interface UnclaimedBannerProps {
  totalUnclaimedTokens: number
  totalUnclaimedUSD: number
}

export function UnclaimedBanner({ totalUnclaimedTokens, totalUnclaimedUSD }: UnclaimedBannerProps) {
  return (
    <div className="reward-banner">
      <div className="reward-banner__left">
        <img src={rewardSVG} alt="reward" />
        <div className="reward-banner__content">
          <h3>Your unclaimed rewards</h3>
        </div>
      </div>
      <div className="reward-banner__right">
        <div className="reward-banner__values">
          <span className="reward-banner__tokens">{totalUnclaimedTokens.toFixed(2)} MOVE</span>
          <span className="reward-banner__usd">{formatCurrency(totalUnclaimedUSD)}</span>
        </div>
      </div>
    </div>
  )
}
